(function() { window.GUID_fbede0f7_5bb3_45ad_a790_699b8ecbb31d = { getGuid: function() { return "fbede0f7-5bb3-45ad-a790-699b8ecbb31d"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let WallType;
        (function (WallType) {
            WallType[WallType["EventWall"] = 0] = "EventWall";
            WallType[WallType["PinsWall"] = 1] = "PinsWall";
            WallType[WallType["DivisionWall"] = 2] = "DivisionWall";
            WallType[WallType["StatsWall"] = 4] = "StatsWall";
            WallType[WallType["MatchDetails"] = 8] = "MatchDetails";
            WallType[WallType["OperatorWall"] = 9] = "OperatorWall";
            WallType[WallType["Other"] = 10] = "Other";
            WallType[WallType["Friends"] = 11] = "Friends";
            WallType[WallType["Settings"] = 12] = "Settings";
            WallType[WallType["TeamMembers"] = 13] = "TeamMembers";
            WallType[WallType["EventsWall"] = 14] = "EventsWall";
            WallType[WallType["SchedulesFinder"] = 15] = "SchedulesFinder";
            WallType[WallType["OpponentsWall"] = 16] = "OpponentsWall";
            WallType[WallType["VideoStreams"] = 17] = "VideoStreams";
            WallType[WallType["Matches"] = 18] = "Matches";
            WallType[WallType["Opponents"] = 19] = "Opponents";
            WallType[WallType["MatchCard"] = 20] = "MatchCard";
            WallType[WallType["BracketWall"] = 21] = "BracketWall";
            WallType[WallType["Leaderboard"] = 22] = "Leaderboard";
            WallType[WallType["MainMenu"] = 23] = "MainMenu";
            WallType[WallType["Messages"] = 24] = "Messages";
            WallType[WallType["PersonaWall"] = 25] = "PersonaWall";
            WallType[WallType["StatsCompareWall"] = 26] = "StatsCompareWall";
            WallType[WallType["EventsWallV2"] = 27] = "EventsWallV2";
            WallType[WallType["OperatorsWall"] = 28] = "OperatorsWall";
            WallType[WallType["TeamsWall"] = 29] = "TeamsWall";
            WallType[WallType["SportsWall"] = 30] = "SportsWall";
            WallType[WallType["GamesWall"] = 31] = "GamesWall";
            WallType[WallType["DivisionsWall"] = 32] = "DivisionsWall";
            WallType[WallType["AwardsWall"] = 33] = "AwardsWall";
            WallType[WallType["RankingsWall"] = 34] = "RankingsWall";
            WallType[WallType["Landing"] = 35] = "Landing";
            WallType[WallType["TeamCompareWall"] = 36] = "TeamCompareWall";
            WallType[WallType["TeamsCompareWall"] = 37] = "TeamsCompareWall";
            WallType[WallType["GameHistoryWall"] = 38] = "GameHistoryWall";
            WallType[WallType["Home"] = 39] = "Home";
            WallType[WallType["CSRDetails"] = 40] = "CSRDetails";
            WallType[WallType["ChildrenWall"] = 41] = "ChildrenWall";
            WallType[WallType["CSRChangelog"] = 42] = "CSRChangelog";
            WallType[WallType["MainSearch"] = 43] = "MainSearch";
            WallType[WallType["NewsfeedWall"] = 44] = "NewsfeedWall";
            WallType[WallType["FrozenCSR"] = 45] = "FrozenCSR";
            WallType[WallType["QuickTournamentsWall"] = 46] = "QuickTournamentsWall";
            WallType[WallType["SurfacesWall"] = 47] = "SurfacesWall";
            WallType[WallType["NotificationsWall"] = 48] = "NotificationsWall";
            WallType[WallType["PersonasWall"] = 49] = "PersonasWall";
            WallType[WallType["None"] = -1] = "None";
        })(WallType = Enumeration.WallType || (Enumeration.WallType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=WallType.pre.js.map
